import React, { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const url = process.env.REACT_APP_API_URL + "/products";
const cartUrl = process.env.REACT_APP_API_URL + "/cart";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");

  /**
   * @desc  Get all the products
   */
  const getProducts = useCallback(async () => {
    const response = await axios.get(`${url}?search=${search}`);
    setProducts(response.data.products);
  }, [search]);

  useEffect(() => {
    getProducts();
  }, [search, getProducts]);

  /**
   * @desc  Get products by category
   */
  const getProductByCategory = useCallback(async () => {
    const response = await axios.get(`${url}/category?category=${category}`);
    setProducts(response.data.products);
  }, [category]);

  useEffect(() => {
    getProductByCategory();
  }, [category, getProductByCategory]);

  /**
   * @desc  Fetch items from a cart
   */
  const fetchCartItems = async () => {
    if (JSON.parse(localStorage.getItem("ekartToken"))) {
      const response = await axios.get(cartUrl, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
        },
      });

      setCartItems(response.data.items);
      setCartCount(response.data.items.length);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  return (
    <AppContext.Provider
      value={{
        products,
        getProducts,
        cartCount,
        setCartCount,
        cartItems,
        setCartItems,
        fetchCartItems,
        setSearch,
        setCategory,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom Hook
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
